<template>
<div>
    <div class="card-grid-item" style="cursor: default;" v-if="!loading">
        <div class="panel mar-no">
            <div class="panel-heading">
                <h2 class="panel-title library-card-panel-title"><i class="text-center fa fa-map-marker"></i> <span>SEGNALAZIONI DA VALIDARE</span></h2>
            </div>
            <div class="panel-body">
                <div class="row" v-for="(report,k) in reports" :key="k" :report="report">
                    <div class="col-xs-1 col-sm-1 col-md-1"><i  v-bind:class="['fa',reportClass(report['Tipo segnalazione']), 'pull-left']"></i></div>
                    <div class="col-xs-7 col-sm-7 col-md-7"><a  @click="reportSelected(k)"><span class="pull-left">  {{report["Titolo"]}}</span></a></div>
                    <div class="col-xs-3 col-sm-3 col-md-3"><span class="pull-left">  {{report["Data rilevazione"] != "None" ? report["Data rilevazione"] : "" }}</span></div>
                    <div class="col-xs-1 col-sm-1 col-md-1"><a @click="reportSelected(k)"><i style="cursor: pointer" class="fa fa-arrow-circle-right"></i></a></div>
                    <hr/>
                </div>
                
            </div>
            <div class="panel-footer">
                <div class="row">
                    <div class="col-xs-6 col-sm-6 col-md-6">
                        <a   v-bind:class="[ 'btn', 'btn-primary', 'btn-labeled', 'fa', 'fa-plus', 'pull-left']" role="button" @click="goAdd()">
                            AGGIUNGI</a>
                    </div>
                    <div class="col-xs-6 col-sm-6 col-md-6">
                        <a  v-bind:class="['btn', 'btn-primary', 'btn-labeled', 'fa', 'fa-search', 'pull-right']" role="button" @click="goSearch()">
                                CERCA</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-grid-item report-modal" v-else>
        <div class="block">
            <p class="circle">
                <span class="ouro ouro3">
                    <span class="left"><span class="anim"></span></span>
                    <span class="right"><span class="anim"></span></span>
                </span>
            </p>
        </div>
    </div>
</div>
</template>
<script>

import axios from 'axios';

export default {
    name: 'ReportPanel',
    props: {
        api: null,
        config: null
    },
    data: function () {
        return {
            reports: {type: Array, value: []},
            loading: false

        }
    },
    methods: {
        search: function() {
            this.load(true);
            this.api.findReports().then(axios.spread((...responses) => {
                let out_data_temp = [];
                let resourse_ids = [];
                for (let response of responses) {
                    let array = [];
                    for (let i=0; i<response.data['tiles'].length; i++) {
                        let item = response.data['tiles'][i]
                        if('display_values' in item) {
                            if(item.display_values.length >0){
                                array = array.concat(item['display_values']);
                            } else {
                                //read data from provisional edits
                                if('provisionaledits' in item && response.data.tiles[0].provisionaledits){
                                    let provEditsKeys = Object.getOwnPropertyNames(response.data.tiles[0].provisionaledits);
                                    if(provEditsKeys.length == 1){
                                        let provEditItem = item.provisionaledits[provEditsKeys[0]].value;
                                        array.push(
                                            {"label": "Tipo segnalazione", "nodeid": "e0b57d50-69f0-11ea-be74-005056868262", "value": provEditItem["e0b57d50-69f0-11ea-be74-005056868262"]});
                                        array.push(
                                            {"label": "Titolo", "nodeid": "c325fc68-69f2-11ea-be74-005056868262", "value": provEditItem["c325fc68-69f2-11ea-be74-005056868262"]});
                                        array.push(
                                            {"label": "Data rilevazione", "nodeid": "e93d76a8-69f0-11ea-be74-005056868262",  "value": provEditItem["e93d76a8-69f0-11ea-be74-005056868262"]});
                                            
                                    }
                                }
                                
                            }
                        }
                        // if('display_values' in item) {
                        //     array = array.concat(item['display_values']);
                        // }
                    }
                    out_data_temp.push(array);
                    resourse_ids.push(response.data['tiles'][0]['resourceinstance']);
                }
                let display_data = {};
                for (let i=0; i<out_data_temp.length; i++)  {
                    let obj_json = {}
                    for (let obj of out_data_temp[i]) {
                        obj_json[obj['label']] = obj['value']
                        }
                    display_data[resourse_ids[i]] = obj_json;
                }

                this.reports = display_data;
                this.load(false);
            },
            (error) => {
                console.log(error);
                this.load(false);
            }
            ));
        },
        reportSelected: function(value) {
            console.log(value);
            let report_id = value;
            window.open(`/report/${report_id}`,'_blank');
        },
        reportClass: function(value) {
            switch(value) {
                case 'Ordinaria':
                    return 'fa-eye';
                case 'Straordinaria':
                    return 'fa-exclamation-triangle';
                case 'Urgente':
                    return 'fa-exclamation-circle';
                default:
                    return 'fa-eye';
            }
        },
        timestampToString(value) {
            let date = "";
            if(value && value!==undefined && value!=="" && value!=="None")  {
                try {
                   date = value; 
                } catch (error) {
                    return "";
                }
            } else {
                return "";
            }
            return date.toLocaleString();
        },
        goAdd: function() {
            window.open(`/add-resource/${this.config.report_graph_id}`,'_blank');
        },
        goSearch: function() {
            window.open(`/search?typeFilter=[{"graphid":"0eb358a6-3172-11ea-8080-080027c5bc64","name":"Segnalazione","inverted":false}]&no_filters=false&page=1`,'_blank');
        },
        load(value) {
            this.loading = value;
        }
    },
    created: function() {
        this.search();
    }
}
</script>

<style scoped>
    .card-grid-item {
        width: 100%;
        text-overflow: ellipsis;
        word-wrap: break-word;
        padding-bottom: 0px;
        min-width: 340px;
   }
    .car-grid-item * {
        display: block;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .panel-body {
        min-height: 251px;
    }

   .addScroll{
    overflow-y:auto;
    height: 200px;
    }

    .card-grid-item.report-modal {
        min-height: 355px;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.1);
        text-align:center;
        display:table; 
        width:420px;

    }

    #app .block {
        display: table-cell; 
        vertical-align:middle;
        background-color: rgba(255, 255, 255, 0.1);
    }
    

    @media only screen and (max-device-width: 480px) {

        .card-grid-item {
            width: unset;
            min-width: 320px;
        }
    
        .card-grid-item.report-modal {

            min-width: 320px;
            width: unset;

            }
        
        #app > div > div.content-panel > div > div {
            flex-direction: column;
        }


    }
</style>

